import React from "react";

const CustomButton = (props) => {
  const { onClick, title, cssClass = "" } = props;
  return (
    <div className="w-full flex justify-center items-center">
      <button
        className={`scrollButton transition ease-in-out duration-300 hover:translate-y-[2px] w-full bg-[#AB7C3B] hover:bg-[#9c6d2d] text-white font-bold py-2 px-10 border border-[#EFD379] rounded-[8px] text-xl lg:text-[32px] cursor-pointer leading-normal lg:leading-[38px] ${cssClass}`}
        onClick={onClick}
      >
        {title}
      </button>
    </div>
  );
};

export default CustomButton;
